import React from 'react';
import MapView from '@arcgis/core/views/MapView';
import { MapPlacement, MapPlugin } from '../arcgis-types';
import DebuggingLayersWidget, { DEBUGGING_WIDGET_ID } from './widgets/debugging-layers-widget';

/**
 * Just for troubleshooting! You probably don't want to add this to your MapView
 * unless you have a feature flag or something similar set.
 */
export default function DebuggingLayers(): MapPlugin {
  const showMeTheLayers = (mapView: MapView | undefined) => async () => {
    console.log('Current Layers:', mapView?.map?.layers);
  };
  return {
    component: {
      element: (mapView: MapView|undefined) => (<DebuggingLayersWidget onClick={showMeTheLayers(mapView)} />),
      key: DEBUGGING_WIDGET_ID,
    },
    initMap: (mapView: MapView) => {
      mapView.ui.add(DEBUGGING_WIDGET_ID, MapPlacement.BottomLeft);
    },
    extendMap: (mapView: MapView) => {
      const component = mapView.ui.find(DEBUGGING_WIDGET_ID);
      mapView.ui.move({ component, position: MapPlacement.BottomLeft });
    },
  };
}
